export const SET_SURVEY_ANSWERS = 'SET_SURVEY_ANSWERS'
export const SET_LOADED_WONUM = 'SET_LOADED_WONUM'
export const SET_LOADING = 'SET_LOADING'
